export default validateEmpresa;

function validateEmpresa(empresa){

	var validateInscricaoEstadual = require("inscricaoestadual");
	var erros = [];
	if(empresa.razao_social.length < 4){
		erros.push("Razão Social Inválida");
	}

	if(empresa.nome_fantasia.length < 4){
		erros.push("Nome Fantasia Inválido");	
	}

	var inscricaoEstadual = empresa.inscricao_estadual;

	if(inscricaoEstadual.length < 3 ||  validateInscricaoEstadual(inscricaoEstadual) == false){
		erros.push("Inscrição Estadual Inválida");		
	}	

	if(!validateCNPJ(empresa.cnpj) ){
		erros.push("CNPJ Inválido");	
	}

	return erros;
}




// WEBPACK FOOTER //
// ./resources/assets/js/components/adm_prospecto/modules/validations/module_validate_empresa.js